import {Links, MappedImage} from "../../utils/fw"

import {UseHeartbeats} from "./HookWrappers"


export const Room = room => {

	const {links, extras, background, ...rest} = room

	return <div style="position: relative" {...rest} path={room.path || room.name.replace(/ /g, "-").replace(/[^A-z-]/g, "")}>

		<MappedImage imageURL={background}>
			<Links links={links} roomName={room.name} />
		</MappedImage>
		{extras}
	</div>
}
